var React = require('react');

function ArrowDownIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.39896 18.9912C6.7309 19.3231 7.2691 19.3231 7.60104 18.9912L13.0104 13.5818C13.3424 13.2499 13.3424 12.7117 13.0104 12.3797C12.6785 12.0478 12.1403 12.0478 11.8083 12.3797L7 17.1881L2.19167 12.3797C1.85973 12.0478 1.32154 12.0478 0.989592 12.3797C0.657647 12.7117 0.657647 13.2499 0.989592 13.5818L6.39896 18.9912ZM7.85 2.39014C7.85 1.9207 7.46944 1.54014 7 1.54014C6.53056 1.54014 6.15 1.9207 6.15 2.39014L7.85 2.39014ZM7.85 18.3901L7.85 2.39014L6.15 2.39014L6.15 18.3901L7.85 18.3901Z","fill":"#194550"}));
}

ArrowDownIcon.defaultProps = {"width":"14","height":"20","viewBox":"0 0 14 20","fill":"none"};

module.exports = ArrowDownIcon;

ArrowDownIcon.default = ArrowDownIcon;
